export default "__VITE_ASSET__D32P$eEf__"